import React from 'react';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import OrderItems from './OrderItems'

const DialogTitle = ((props) => {
  const { children, onClose, ...other } = props;
  const styleButton = {
      position: 'absolute',
      right: 8,
      top: 8,
    };
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" onClick={onClose} style={styleButton}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = (MuiDialogContent);

const DialogActions = (MuiDialogActions);

export default function OrderItemsDialogs(props) {

  const componentConstants = {
      ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }
    const componentProps = {
        ...props.componentProps
    }

  const handleClose = () => {
    props.componentMethods.setManagerState({openOrderItemsDialog: false})
  };
  return (
    <div>
      <Dialog onClose={handleClose} aria-labelledby="orderItemsTitle" open={props.openOrderItemsDialog}>
        <DialogTitle id="orderItemsTitle" onClose={handleClose}>
          {componentConstants.language.LANG_ORDER_ITEMS_DIALOG_TITLE}{componentMethods.getManagerState().viewOrderItem.ordersID}
        </DialogTitle>
        <DialogContent dividers>
          <OrderItems ordersID={componentMethods.getManagerState().viewOrderItem.ordersID} ordersSha={componentMethods.getManagerState().viewOrderItem.ordersSha} componentProps={componentProps} componentConstants={componentConstants} componentMethods={componentMethods} />
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </div>
  );
}